/**
 * Navigation menu configuration for the dashboard
 * Centralized menu items with role-based access control
 * freeAccess: true = accessible on free (Plus) plan
 */
import { 
  FaHome, FaUsers, FaUserTie, FaClipboardList, FaHeart, 
  FaFileAlt, FaGraduationCap, FaCalculator, FaHeartbeat
} from 'react-icons/fa';

export const menuItems = [
  { 
    path: '/dashboard', 
    icon: FaHome, 
    label: 'Dashboard', 
    roles: ['advisor', 'manager', 'super_admin', 'client', 'growth_partner'],
    freeAccess: true
  },
  { 
    path: '/dashboard/clients', 
    icon: FaUsers, 
    label: 'Clients', 
    roles: ['advisor', 'manager', 'super_admin'],
    freeAccess: true
  },
  { 
    path: '/dashboard/team/add-advisor', 
    icon: FaUserTie, 
    label: 'Add Advisor', 
    roles: ['manager', 'super_admin'],
    freeAccess: true
  },
  { 
    path: '/dashboard/team-report', 
    icon: FaClipboardList, 
    label: 'Team Report', 
    roles: ['manager', 'super_admin'],
    freeAccess: true
  },
  { 
    path: '/dashboard/my-plan', 
    icon: FaFileAlt, 
    label: 'Arth Kundli', 
    roles: ['client'],
    freeAccess: false,
    mode: 'guided'
  },
  { 
    path: '/dashboard/family-vault', 
    icon: FaHeart, 
    label: 'My Family Should Know', 
    roles: ['client', 'advisor', 'manager'],
    freeAccess: true,
    mode: 'diy'
  },
  { 
    path: '/dashboard/money-school', 
    icon: FaGraduationCap, 
    label: 'Money School', 
    roles: ['client', 'advisor', 'manager', 'super_admin'],
    freeAccess: false,
    mode: 'diy'
  },
  { 
    path: '/dashboard/money-meter', 
    icon: FaCalculator, 
    label: 'Money Meter', 
    roles: ['client', 'advisor', 'manager'],
    freeAccess: false,
    mode: 'diy'
  },
  { 
    path: '/dashboard/paiso-ki-pathshala', 
    icon: FaGraduationCap, 
    label: 'Paiso Ki Pathshala', 
    roles: ['client', 'advisor', 'manager', 'super_admin'],
    freeAccess: true,
    mode: 'diy'
  },
  { 
    path: '/dashboard/financial-health-checkup', 
    icon: FaHeartbeat, 
    label: 'Financial Health Check-Up', 
    roles: ['client'],
    freeAccess: true,
    mode: 'diy'
  },
];

/**
 * Filter menu items based on user role
 */
export const getMenuItemsForRole = (role) => {
  return menuItems.filter(item => item.roles.includes(role));
};
